<script setup lang="ts">
const { jwt, isSupportConnection } = useLocalStorage()
const route = useRoute()

const COPILOT_BASE_URL = 'https://copilot-nine-rho.vercel.app/'

const copilotSrc = computed(() => {
  const params = new URLSearchParams({
    token: jwt.value,
    mode: 'beta',
    isSupportConnection: String(isSupportConnection.value),
    page: route.path.replace(/^\//, '')
  })
  return `${COPILOT_BASE_URL}?${params.toString()}`
})
</script>

<template>
  <div class="h-screen">
    <iframe
      class="h-full w-full"
      :src="copilotSrc"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation allow-downloads allow-popups"
      allow="clipboard-write; microphone"
    />
  </div>
</template>
